const BASE_URL = import.meta.env.VITE_API_URL || '/api';

class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

async function request(endpoint, options = {}) {
  const token = localStorage.getItem('super_admin_token');

  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  let url = `${BASE_URL}${endpoint}`;

  if (options.params) {
    const entries = Object.entries(options.params).filter(([, v]) => v != null && v !== '');
    if (entries.length) url += `?${new URLSearchParams(Object.fromEntries(entries))}`;
  }

  const { params: _, ...fetchOptions } = options;
  const response = await fetch(url, { ...fetchOptions, headers });

  if (response.status === 401) {
    localStorage.removeItem('super_admin_token');
    localStorage.removeItem('super_admin_user');
    window.location.href = '/super-admin/login';
    throw new ApiError('Session expired', 401, null);
  }

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));

    // Build a human-readable message from the API response
    let message = body.message || body.error || response.statusText;
    if (body.details && Array.isArray(body.details)) {
      message = body.details.map((d) => d.message || d.field).join('. ');
    }

    throw new ApiError(message, response.status, body);
  }

  if (response.status === 204) return null;
  return response.json();
}

const superAdminApi = {
  get: (endpoint, params) => request(endpoint, { method: 'GET', params }),
  post: (endpoint, data) => request(endpoint, { method: 'POST', body: JSON.stringify(data) }),
  put: (endpoint, data) => request(endpoint, { method: 'PUT', body: JSON.stringify(data) }),
  patch: (endpoint, data) => request(endpoint, { method: 'PATCH', body: JSON.stringify(data) }),
  delete: (endpoint) => request(endpoint, { method: 'DELETE' }),
};

export default superAdminApi;
export { ApiError };
